import { clearToken } from './apiFetch';

export const logout = () => {
    clearToken();
    sessionStorage.setItem('isAuthenticated', 'false');
    sessionStorage.setItem('sessionMessage', 'You have been logged out');
    window.location.reload();
};
